import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from '../../../hooks/useStyles';
import { FleetAsset } from '../../../types/fleet';
import FleetAssetInlineLabel from '../shared/FleetAssetInlineLabel';
import FleetAssetRefuelForm from './FleetAssetRefuelForm';

type Props = {
  isOpen: boolean;
  onClose: (update?: boolean) => void;
  selectedAsset: FleetAsset;
};

function FleetAssetRefuelModal({ selectedAsset, onClose, isOpen }: Props) {
  const { css } = useStyles();

  return createPortal(
    <Modal
      animate
      closeable
      onClose={() => onClose()}
      isOpen={isOpen}
      size="auto"
      autoFocus={false}
    >
      <FlexRow
        gap={0}
        classNames={css({
          justifyContent: 'space-between',
          margin: '6px 2rem 0px 0px',
        })}
      >
        <ModalHeader
          className={css({
            marginBottom: '0 !important',
          })}
        >
          Carga de combustible
        </ModalHeader>
      </FlexRow>
      <ModalBody>
        <FlexColumn
          classNames={css({
            width: '70vw',
            maxWidth: '600px',
            minWidth: '350px',
            boxSizing: 'border-box',
            padding: '1rem',
            borderTop: '1px solid rgb(226, 226, 226)',
            maxHeight: '80vh',
          })}
        >
          <FleetAssetInlineLabel asset={selectedAsset} />
          <FleetAssetRefuelForm
            assetId={selectedAsset._id}
            onCancel={() => onClose(false)}
            afterSave={() => onClose(true)}
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body,
  );
}

export default memo(FleetAssetRefuelModal);
